import React from 'react';
import { GoogleMap, useJsApiLoader, HeatmapLayer } from '@react-google-maps/api';
import { useTheme } from '@mui/material/styles';
import { Order } from '../../../../app/services/api/orderManagementClient';

interface OrdersByMarketProps {
  orders: Order[];
}

const OrdersByMarket = ({ orders }: OrdersByMarketProps) => {
  const theme = useTheme();
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyAn3FgyVwPfbulsKlqDwOWTpwg2ChYe-yk',
    libraries: ['visualization'],
  });

  const heatmapData: { location: { lat: number, lng: number }, weight: number }[] = [
  ];

  // Group orders by supplierName (market)
  const marketCounts: { [market: string]: number } = {};
  orders.forEach(order => {
    marketCounts[order.supplierName] = (marketCounts[order.supplierName] || 0) + 1;
  });

  const mapContainerStyle = {
    width: '100%',
    height: '200px',
    color: theme.palette.text.primary,
    fontSize: theme.typography.textSM.fontSize,
  };

  const center = {
    lat: 39.8283,
    lng: -98.5795,
  };

  return (
    <div>
      {Object.entries(marketCounts).map(([market, count]) => (
        <div key={market}>{market}: {count}</div>
      ))}
      {isLoaded ? (
        <GoogleMap mapContainerStyle={mapContainerStyle}
          center={center}
          zoom={4}
          options={{
            disableDefaultUI: true,
            streetViewControl: false,
            mapTypeControl: false,
            zoomControl: false,
            fullscreenControl: true,
          }}>
          <HeatmapLayer
            data={heatmapData.map((h) => ({
              location: new google.maps.LatLng(h.location.lat, h.location.lng),
              weight: h.weight,
            }))}
          />
        </GoogleMap>
      ) : null}
    </div>
  );
};

export default OrdersByMarket;